import { forwardRef, memo } from 'react';
import { SpaceProps } from 'styled-system';
import { SeparatorProps } from './separator.types';
import { HStack } from '../stack';
import { Text } from '../text';

import { Separator } from './separator';

interface SeparatorTextProps extends SpaceProps {
  word: string;
  fill?: SeparatorProps['fill'];
  textColor?: SeparatorProps['fill'];
}

export const SeparatorText = memo(
  forwardRef<HTMLDivElement, SeparatorTextProps>(
    (
      { word, fill = 'gray.200', textColor = 'gray.500', ...spaceProps },
      ref
    ) => {
      return (
        <HStack
          ref={ref}
          padding={4}
          width="100%"
          align="center"
          justify="center"
          spacing="xs"
        >
          <Separator fill={fill} />
          <Text
            variant="caption-13"
            color={textColor}
            style={{ whiteSpace: 'nowrap' }}
            {...spaceProps}
          >
            {word}
          </Text>
          <Separator fill={fill} />
        </HStack>
      );
    }
  )
);
